document.addEventListener('DOMContentLoaded', function () {
  console.log('Script loaded and DOM is ready.');

  const load_more_btn = document.querySelector('.load-more_btn');
  const load_more_spinner = document.querySelector('.load-more_spinner');

  if (!load_more_btn || !load_more_spinner) {
  /*  console.error('Critical elements not found.');*/
    return;
  }

  async function getNextPage(products_on_page) {
    try {
      const nextUrl = products_on_page?.dataset?.nextUrl;

      if (!nextUrl) {
        return null;
      }

      const res = await fetch(nextUrl);
      if (!res.ok) {
        throw new Error(`Failed to fetch next page. Status: ${res.status}`);
      }
      return await res.text();
    } catch (error) {
      return null;
    }
  }

  function updateLoadMoreButtonVisibility() {
    const products_on_page = document.getElementById('product-grid');
    if (!products_on_page) {
      load_more_btn.style.display = 'none';
      return;
    }

    const nextUrl = products_on_page.dataset.nextUrl;

    if (nextUrl) {
      load_more_btn.style.display = 'flex';
    } else {
      load_more_btn.style.display = 'none';
    }
  }

  updateLoadMoreButtonVisibility();

  setInterval(function () {
  //  console.log('Checking data-next-url...');
    updateLoadMoreButtonVisibility();
  }, 1000); 

  async function loadMoreProducts() {
    if (!load_more_btn || !load_more_spinner) {
      //console.error('Critical elements not found.');
      return;
    }

    const products_on_page = document.getElementById('product-grid');
    if (!products_on_page) {
      //console.error('Product grid (#product-grid) not found.');
      return;
    }

    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'flex';

    try {
      const nextPage = await getNextPage(products_on_page);

      if (!nextPage) {
        //console.warn('No more pages available.');
        load_more_spinner.style.display = 'none';
        return;
      }

      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

      const productgrid = nextPageDoc.getElementById('product-grid');
      const new_products = productgrid.getElementsByClassName('grid__item');
      const new_url = productgrid.dataset.nextUrl;

      const fragment = document.createDocumentFragment();

      for (let i = 0; i < new_products.length; i++) {
        const existingProduct = document.querySelector(`[data-id="${new_products[i].dataset.id}"]`);
        if (!existingProduct) {
          fragment.appendChild(new_products[i].cloneNode(true));
        } else {
          //console.log(`Duplicate product skipped: ${new_products[i].dataset.id}`);
        }
      }

      products_on_page.appendChild(fragment);

      products_on_page.dataset.nextUrl = new_url || '';
      load_more_spinner.style.display = 'none';

      updateLoadMoreButtonVisibility();
    } catch (error) {
     // console.error('Error loading more products:', error);
      load_more_spinner.style.display = 'none';
      load_more_btn.style.display = 'flex'; 
    }
  }

  window.loadMoreProducts = loadMoreProducts;
});